function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.00685 5.68753L13.8083 11.489C14.0639 11.7446 14.0639 12.1471 13.8083 12.3899L12.3388 13.8594C12.0896 14.1086 11.6871 14.1086 11.4379 13.8594L5.61725 8.03879C4.13494 8.59466 2.40344 8.28159 1.21503 7.09318C-0.254504 5.63003 -0.388679 3.33628 0.799728 1.7134L3.24683 4.16049L4.15411 3.2596L1.70062 0.799728C3.32989 -0.388679 5.61725 -0.254504 7.08679 1.21503C8.29436 2.429 8.60105 4.19244 8.00685 5.68753ZM5.84728 6.46701L11.8915 12.5113L12.4538 11.9426L6.41592 5.90476C6.70983 5.52779 6.90151 5.10609 6.97818 4.65246C7.13791 3.76434 6.87595 2.81234 6.18591 2.1223C5.57893 1.5217 4.78027 1.24057 3.988 1.2853L5.96229 3.25959L3.25323 5.96865L1.27894 3.99436C1.23421 4.78663 1.51534 5.59168 2.12232 6.19227C2.78681 6.85676 3.70048 7.11872 4.56942 6.99093C5.02306 6.92704 5.45753 6.75453 5.84728 6.46701Z",
  fill: "black"
});

function SvgMaintenanceTiny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceTiny);
export default __webpack_public_path__ + "static/media/MaintenanceTiny.69a87628.svg";
export { ForwardRef as ReactComponent };